<template>
  <div v-if="tags" class="d-flex flex-row">
    <i-badge
      v-for="tag in tags.slice(0, 4)"
      :key="tag.id"
      class="document-tag"
      :colour="iBadgeColours.NEUTRAL"
      :outline="true"
      icon="small-delete-1"
      :has-trailing-icon="showRemoveButton"
      :interactable="showRemoveButton"
      :label="tag.value"
      @right-icon-click="removeTag(tag)"
      @click.stop
    ></i-badge>

    <div v-if="tags.length > 4" class="other-tags">
      <div
        :id="`other-tags-${componentId}`"
        class="i-pill i-text-subheading-3 tag"
      >
        <span class="outline"
          ><i-icon symbol="medium-bookmark-tag" :size="12"></i-icon
        ></span>
      </div>
      <b-tooltip :target="`other-tags-${componentId}`">
        Other tags:
        {{
          tags
            .slice(4)
            .map((t) => t.value)
            .join(', ')
        }}
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import { iBadge, iBadgeColours, iIcon } from '@inscribe/signal';

export default {
  components: { iBadge, iIcon },
  props: {
    document: {
      type: Object,
      default: null,
    },
    showRemoveButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hovering: false,
      iBadgeColours,
      tags: [],
      componentId: crypto.randomUUID(),
    };
  },
  watch: {
    'document.tags': {
      immediate: true,
      handler: function () {
        this.tags = this.document.tags;
      },
    },
  },
  mounted() {
    this.tags = this.document?.tags || [];
  },
  methods: {
    removeTag(tag) {
      const tagIdx = this.tags.findIndex((currTag) => currTag.id === tag.id);
      if (tagIdx > -1) {
        this.tags.splice(tagIdx, 1);
        this.$store
          .dispatch('deleteDocumentTag', {
            document: this.document,
            tagId: tag.id,
          })
          .then(
            () => {
              this.$notify({
                group: 'api',
                type: 'success',
                duration: 2000,
                text: 'Tag successfully removed.',
              });
            },
            (error) => {
              this.tags.splice(tagIdx, 0, tag);
              this.$notify({
                group: 'api',
                type: 'error',
                duration: 5000,
                text: error.response,
              });
            },
          );
      }
    },
  },
};
</script>

<style lang="scss">
.document-tags {
  .dropdown-toggle {
    height: unset;
  }

  .other-tags {
    height: 22px;
    margin-right: 6px;

    .outline {
      height: 22px;
    }
  }

  .document-tag {
    margin-right: 6px;
  }
}
</style>
